// extracted by mini-css-extract-plugin
export default {"paginationPageDropdownWrap":"InviteUser_paginationPageDropdownWrap__mA9Lv","inviteUser":"InviteUser_inviteUser__jVYJP"};